<script lang="ts">
</script>

<article class="container">
	<div class="postHeader">
		<div class="postIcon" />
		<div class="postHeading">
			<div class="textShort" />
			<div class="textShort" />
		</div>
	</div>
	<div class="textLong" />
	<div class="textLong" />
</article>

<style>
	.postHeader {
		display: flex;
		position: relative;
		flex: auto;
		flex-direction: row;
		margin-block-end: 50px;
	}

	.postHeading {
		display: flex;
		flex-wrap: wrap;
		inline-size: 100%;
		margin-block-start: 7px;
	}

	.postIcon {
		flex-shrink: 0;
		block-size: 54px;
		inline-size: 54px;
		margin-inline-end: 18px;
		border-radius: 50%;
		background-color: #e6edf1;
	}

	.textLong {
		block-size: 12px;
		inline-size: 100%;
		margin-block-end: 20px;
		border-radius: 12px;
		background-color: #e6edf1;

		/* & + & {
			width: 80%;
		} */
	}

	.textShort {
		block-size: 12px;
		inline-size: 40%;
		margin-block: 0 7px;
		margin-inline: 0 60%;
		border-radius: 12px;
		background-color: #e6edf1;

		/* & + & {
    margin: 0 4px 7px 0;
   } */
	}

	.container {
		display: flex;
		position: relative;
		flex-direction: column;
		inline-size: 45%;
		margin-block: var(--gutterDefault);
		margin-inline: 0;
		padding: 18px;
		border-radius: 2px;
		background-color: #fff;
		box-shadow: var(--contentShadow);
	}

	@media screen and (max-width: 719px) {
		.container {
			inline-size: 100%;
		}
	}
</style>
